export const T = {
  en_GB: {
    settings: "Settings",
    title: "Usage",
    description: "Metered cost per month for 3rd-party features and AI. Prices in EUR, excl. VAT.",
    monthlyCost: "Monthly cost",
    loading: "Loading…",
    noUsageYet: "No metered usage yet.",
    month: "Month",
    cost: "Cost",
    events: "Events",
    feature: "Feature",
    user: "User",
    noUsage: "No usage.",
    byFeature: (month: string) => `By feature — ${month}`,
    byUser: (month: string) => `By user — ${month}`,
    types: {
      ai: "AI Inference",
      sumsub: "Sumsub ID verification",
      trapets: "Trapets screening",
      whereby: "Whereby meetings",
      file_transcription: "File transcription",
      web: "Web search & fetch",
      enin: "ENIN lookup",
      idura: "Idura eID & signing",
      sms: "SMS",
    } as Record<string, string>,
  },
  nb_NO: {
    settings: "Innstillinger",
    title: "Forbruk",
    description:
      "Målt kostnad per måned for tredjepartsfunksjoner og AI. Priser i EUR, ekskl. mva.",
    monthlyCost: "Månedlig kostnad",
    loading: "Laster…",
    noUsageYet: "Ikke noe målt forbruk ennå.",
    month: "Måned",
    cost: "Kostnad",
    events: "Hendelser",
    feature: "Funksjon",
    user: "Bruker",
    noUsage: "Ikke noe forbruk.",
    byFeature: (month: string) => `Per funksjon — ${month}`,
    byUser: (month: string) => `Per bruker — ${month}`,
    types: {
      ai: "AI-inferens",
      sumsub: "Sumsub ID-verifisering",
      trapets: "Trapets-screening",
      whereby: "Whereby-møter",
      file_transcription: "Filtranskribering",
      web: "Nettsøk og henting",
      enin: "ENIN-oppslag",
      idura: "Idura eID og signering",
      sms: "SMS",
    } as Record<string, string>,
  },
} as const;
